<template>
  <el-dialog v-loading="loading" custom-class="vaultDetailDialog" :visible.sync="dialogVisible" :lock-scroll="false" top="10vh" :before-close="closeDialog">
    <template v-if="vaultDetail">
      <h2 slot="title">{{ $t('vault.ConsignforSale') }}</h2>
      <div class="vault-detail-body">
        <div class="vault-left">
          <div class="vault-img">
            <div class="sold" v-if="vaultDetail.Status == 5">{{ $t('vault.Sold') }}</div>
            <el-image class="vault-big-img" :src="bigImg + '?imageView2/2/w/326'" :preview-src-list="[bigImg]" fit="contain">
            </el-image>
          </div>
          <div class="vault-thumb-list">
            <el-image class="vault-thumb" :src="img + '?imageView2/2/w/326'" fit="contain" v-for="(img, idx) in thumbList" :key="idx" @click="bigImg = img">
            </el-image>

          </div>
        </div>
        <div class="vault-right">
          <div class="vr-title">
            {{ cardDetail.Title || vaultDetail.Title }}
            <template v-if="cardDetail.EffectiveTime && vaultDetail.Status == 4">
              <div>
                <span :class="{ 'text_red': (cardDetail.itemEndClass == 1) }">{{ $t('colon.timeLeft') }}
                  <em>{{ cardDetail.itemEnd }}</em></span>
                <span>{{ setTime(cardDetail.EffectiveTime) }}</span>
              </div>
            </template>

            <!-- <template v-if="cardDetail.EffectiveTime && vaultDetail.Status == 4">
              <div>
                <span>{{$t('colon.timeLeft')}}<em>{{CountDown(list.EffectiveTime,0)}}</em></span>
                <span>{{ cardTimer(cardDetail.EffectiveTime) }}</span>
              </div>
            </template> -->
            <div class="text_blue">{{ $t('vault.VaultID') }}：{{ vaultDetail.Code }}</div>
          </div>
          <!-- <div><span :class="getCountDown(list.EffectiveTime)==1?'text_red':''">{{$t('colon.timeLeft')}}
          <em>{{CountDown(list.EffectiveTime,0)}}</em></span>{{setTime(list.EffectiveTime)}}</div> -->
          <template v-if="vaultDetail.Status == 4">
            <div class="vault_td">
              <div class="current-price">
                <span>
                  {{ cardDetail.ByWay === 2 ? $t('colon.CurrentBid') : $t('colon.price') }}
                </span>
                <span class="price" style="font-size: 24px;font-weight: bold;">
                  USD {{ ThousandAndDecimal(cardDetail.USD_Price || cardDetail.Price) }}
                </span>
              </div>
              <div>
                <span class="icon_auction" v-if="cardDetail.ByWay === 1 && cardDetail.Bargain == 1">
                  <!-- @*一口价 议价 报价次数*@ -->
                  {{ cardDetail.AuctionCount }} {{ $t('base.Offers') }}
                </span>
                <span class="icon_auction" v-if="cardDetail.ByWay === 2">
                  <!-- @*竞价数*@ -->
                  {{ cardDetail.AuctionCount }} {{ $t('base.bids') }}
                </span>
              </div>
            </div>
          </template>

          <div class="vr-price">
            <div class="current-price">
              <span>{{ vaultDetail.Status == 1 ? $t('vault.EstimatedValue') + ':' : $t('colon.price') }}</span>
              <span class="text_lg">USD {{ ThousandAndDecimal(vaultDetail.UsdPrice || vaultDetail.EstimatePrice)
              }}</span>
            </div>
            <span class="text_gray small_text">{{ $t('vault.EstimatedVaultValue') }}</span>
          </div>
          <template v-if="codeScore && codeScore.Score">
            <div class="codeScore">
              <div>
                <span class="text_blue">{{ codeScore.Company }}</span>
                <span>{{ codeScore.Score }}</span>
              </div>
              <div>
                <span class="text_red">POP</span>
                <span>{{ codeScore.TotalPopulation }}</span>
              </div>
              <div>
                <span class="text_yellow">POP HIGHER</span>
                <span>{{ codeScore.TotalAbovePopulation }}</span>
              </div>
            </div>
          </template>
          <template v-if="vaultDetail.Defect">
            <div class="defect-info text_red"><span>{{ $t('vault.Defect') }}：</span><span class="defect-desc">{{
              vaultDetail.DefectDsc }}</span></div>
          </template>
          <template v-if="vaultDetail.Status == 5">
            <div class="vr-sold-tip">
              <p class="sold-text">{{ $t('vault.Sold') }}</p>
              <p class="sold-sub">{{ $t('vault.accountberestricted') }}</p>
            </div>
          </template>

          <template v-if="vaultDetail.ApplyStatus != 0">
            <div :class="['vr-user', 'vault-seller', 'vSeler-status-' + vaultDetail.ApplyStatus]">
              <div class="vr-user-left">
                <el-image class="avatar-img" :src="`${vaultDetail.Photo || '/static/images/vault/icon_Person.png'}?imageView2/2/h/100`" fit="contain">
                </el-image>
                <div class="vr-user-info">
                  <span class="vr-nickname">{{ vaultDetail.ResalerName }}</span>
                  <span :class="['vr-tag', 'vs-status']">{{ ApplyStatusEnum[vaultDetail.ApplyStatus] }}</span>
                </div>
              </div>
              <span @click="allContact(vaultDetail.Resaler)" class="wy-chat">
                <i class="vr-icon el-icon-chat-dot-round"></i>
              </span>
              <!-- <a :href="`?account=${WyAccId}&secret=${WyToken}&to=${vaultDetail.Resaler}&chat=true&token=${token}`" class="wy-chat" target="_blank">
                <i class="vr-icon el-icon-chat-dot-round"></i>
              </a> -->
            </div>
          </template>

          <div class="vr-btn">
            <!-- @*ApplyStatus: 委托的状态 0待委托   1申请中   2委托中 *@
                 @*Status：1未上架、2提货中、3已提货、4上架、5已售出*@ -->
            <template v-if="[0].includes(vaultDetail.ApplyStatus) && [1].includes(vaultDetail.Status)">
              <el-button :disabled="vaultDetail.Repeat" v-bind:class="['resale-btn']" :type="vaultDetail.Repeat ? 'info' : 'primary'" v-on:click="handleCardOperation(vaultDetail, 'entrust')">
                {{ $t('vault.ConsignforSale') }}
              </el-button>
            </template>
            <template v-if="[1, 2].includes(vaultDetail.ApplyStatus) && [1].includes(vaultDetail.Status)">
              <!-- :disabled="updateStatusloading" :loading="updateStatusloading" -->
              <el-button v-bind:class="['resale-btn']" type="primary" v-on:click="handleCardOperation(vaultDetail, 'cancel')">
                {{ $t('vault.CancelConsignment') }}
              </el-button>
            </template>
            <el-button type="primary" v-if="vaultDetail.CardId"><router-link class="" :to="{ path: '/carddetails/' + vaultDetail.CardId }">{{ $t('vault.ViewItems') }}</router-link></el-button>
          </div>

        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import commonEventJs from '@/common/CommonEventJs';
import { getInfo, countDown, getTime, setUTC ,GoYunXin} from "@/api/public";

export default {
  name: 'addressbox',

  data() {
    return {
      codeScore: '',
      userInfo: getInfo(),

      token: getInfo().ChineseToken, // 用户token
      MemberId: getInfo().MappingUserId, // 用户ID 
      UserId: getInfo().Id,  // 海外ID用户ID
      MemberMobile: getInfo().TelPhone,
      MemberRealName: getInfo().NickName,
      WyAccId: getInfo().WyAccId,
      WyToken: getInfo().WyToken,

      nowData: setUTC(new Date().getTime(), -8),
      dislogType: this.$enumInfo.dislogType,
      loading: false,
      bigImg: '',
      thumbList: [],
    }
  },
  props: {
    dialogVisible: Boolean,
    vaultDetail: Object,
    cardDetail: {
      type: Object,
      default: {}
    }
  },
  watch: {
    nowData: {
      immediate: true,
      handler(val) {
        const that = this
        try {
          let itemEnd = that.cardDetail.EffectiveTime.toString().replace(/-/g, "/")
          itemEnd = setUTC(itemEnd, -8, 'cn')
          that.cardDetail.itemEnd = countDown(itemEnd, val)
          //  console.log(that.cardDetail.itemEnd,'that.cardDetail.itemEnd')
          that.cardDetail.itemEndClass = countDown(itemEnd, val, 0)
          // console.log(that.cardDetail.itemEndClass,'that.cardDetail.itemEndClass')
        } catch (e) {

          //console.log('itemEnd:', e, 'val:', val)
        }
      }
    },
    vaultDetail: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getStarCardSku(val)
          this.bigImg = val.TitImg + '?imageView2/2/w/326' || ''
          //val.EffectiveTime=this.nowData 
          // if(EffectiveTimeval){
          //   itemEnd = itemEnd.toString().replace(/-/g, "/")
          // }
          try {
            this.thumbList = val.images.split(',') || []
          } catch (e) { }
        }
      }
    }
  },
  computed: {
    ApplyStatusEnum() {
      return {
        0: this.$t('vault.AwaitingConsignment'),
        1: this.$t('vault.ApplicationPending'),
        2: this.$t('vault.Accepted'),//委托中
      }
    },
    ThousandAndDecimal() {
      return function (num) {
        //金额千分位
        return commonEventJs.thousandAndDecimal(num);
      }
    },
  },
  mounted() {

    this.userInfo = getInfo()
    this.cardTimer()
  },
  methods: {

    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    cardTimer() {
      setTimeout(() => {


        var nowTime = new Date().getTime()
        this.nowData = setUTC(nowTime, -8)
        this.cardTimer()
      }, 1000)
    },

    closeDialog() {
      this.dislogType['vaultDetails'] = false
    },
    handleCardOperation(item, type = '') {
      const that = this
      //type:entrust 单卡委托 2 cancel 撤销代卖
      if (item && type) {
        that.$emit('handleCardOperation', item, type);
      } else {
        that.$message.warning('缺少参数');
      }
    },
    getStarCardSku(obj) {
      const that = this
      try {
        const StarCardSku = obj.StarCardSku
        if (StarCardSku.CertificationNumber && StarCardSku.ProfessionalGrader) {
          const _code = StarCardSku.CertificationNumber.replace(/[^a-zA-Z0-9]/g, "");
          let data = {
            code: _code,
            companyCode: StarCardSku.ProfessionalGrader,
            category: 'dee8e93d-bf0d-46d7-a817-45db58756940'
          }
          that.$get(this.$interface.GetNewCommodityByCodeScore, data).then(res => {
            if (res.result > 0) {
              that.codeScore = res.data;
            }
          })
        }
      } catch (e) { }
    },

    allContact(val) {
      console.log('allContact', val, this.userInfo, this.vaultDetail.CardId)
      if (this.userInfo) {
        // GoYunXin(this.userInfo, val, this.vaultDetail.CardId, 1000)
        GoYunXin(this.userInfo, val)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
  }
}

</script>
<style scoped>
.vault-detail-body {
  display: flex;
  gap: 4%;
  color: #333;
}

.vault-left {
  flex: 4;
}

.vault-img {
  position: relative;
}

.sold {
  position: absolute;
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 9;
  background-size: auto 100%;
  right: 0;
  bottom: 0;
  border-radius: 0 0 4px 4px;
  background-color: #a0a0a0;
}

.vault-big-img {
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 6px;
  aspect-ratio: 1 / 1;
}

.vault-big-img>>>.el-image__inner {
  width: 100%;
  display: block;
}

.vault-thumb-list {
  margin-top: 10px;
  display: flex;
  overflow-x: auto;
  gap: 8px;
  white-space: nowrap;
}

.vault-thumb {
  width: 60px;
  height: 60px;
  object-fit: cover;
  cursor: pointer;
  flex-shrink: 0;
  background-color: #f7f7f7;
  border-radius: 6px;
}

.vault-right {
  flex: 6;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.vr-title {
  font-size: 18px;
  font-weight: bold;
  border-bottom: 0.5px solid #e0e0e0;
  padding-bottom: 12px;
  position: relative;
}

.vr-price {
  font-size: 14px;
  /* font-weight: bold; */
}

.vr-merchant {
  font-size: 14px;
  color: #666;
}

.vr-sold-tip {
  background-color: #efefef;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 12px;
  border-radius: 4px;
}

.sold-text {
  color: #333;
  font-size: 16px;
  margin: 0 0 4px 0;
}

.sold-sub {
  color: #a0a0a0;
  font-size: 12px;
  margin: 0;
}

.vr-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(5, 130, 63, 0.10);
  border: 1px solid #C6E5D5;
  border-radius: 4px;
  padding: 8px 10px;
}

.vr-user-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vr-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.vr-user-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.vr-nickname {
  font-size: 14px;
  color: #05823F;
}

.vr-tag {
  font-size: 12px;
  color: #05823F;
  padding: 1px 6px;
  border-radius: 2px;
}

.vr-icon {
  font-size: 22px;
  color: #999;
  cursor: pointer;
}

.vr-btn {}

.el-button--primary a {
  color: #fff;
}

.vr-title div {
  font-size: 16px;
  margin-top: 10px;
}

.vr-title div>span+span {
  margin-left: 25px;
}

.current-price {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.current-price>span {
  min-width: 74px;
}

.vault_td {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon_auction {
  display: flex;

}

.icon_auction:before {
  content: "";
  background: url(../../../static/images/icon/icon_gray_auction.svg) no-repeat 0 1px;
  background-size: auto 80%;
  display: block;
  width: 18px;
  height: 18px;
}

.codeScore {
  display: flex;
  gap: 16px;
}

.codeScore>div {
  border: 1px solid #e0e0e0;
  padding: 4px 12px;
  border-radius: 6px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/vaultDetail.vue